// Ravn: one-tap size buttons in the cart drawer's "Complete the look" (snippets/ravn-cart-upsell.liquid).
// Loaded from the layout, because the drawer's markup is swapped in after page load and inline scripts in it don't run.
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-ravn-upsell-add]');
  if (!button || button.disabled) return;
  event.preventDefault();
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  const id = button.dataset.variantId;
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((component) => component.dataset.sectionId)
    .filter(Boolean)
    .join(',');
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: id, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections }),
    }).then((r) => r.json());
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'ravn-upsell',
        itemCount: 1,
        sections: response.sections,
        didError: Boolean(response.status),
      },
    });
  } catch (error) {
    deferred.reject(error);
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
